import type { AcquisitionChannel, AcquisitionSource, RecordedSource, SourceAskedAt } from '../types/insights'

/**
 * "Hoe kwam je bij ons?" (docs/INZICHT.md §5.6). Vrijwillig, één tik, nooit verplicht. De server
 * controleert met dezelfde regels; wat niet klopt, wordt genegeerd in plaats van geweigerd (een
 * bestelling of afspraak mag nooit mislukken op deze vraag).
 */

export const ACQUISITION_CHANNELS: readonly AcquisitionChannel[] = ['instagram', 'google', 'maps', 'via-iemand', 'nieuwsbrief', 'langsgelopen', 'anders']

/** "Anders": hoogstens zoveel tekens vrije tekst. */
export const SOURCE_OTHER_MAX = 60

/** Een geldig antwoord, of `null`. Vrije tekst alleen bij "anders", ingekort en zonder dubbele spaties. */
export function normalizeSource(raw: unknown): AcquisitionSource | null {
  if (!raw || typeof raw !== 'object') return null
  const r = raw as { channel?: unknown; other?: unknown }
  const channel = ACQUISITION_CHANNELS.find((c) => c === r.channel)
  if (!channel) return null
  if (channel !== 'anders') return { channel }
  const other = typeof r.other === 'string' ? r.other.replace(/\s+/g, ' ').trim().slice(0, SOURCE_OTHER_MAX).trim() : ''
  return other ? { channel, other } : { channel }
}

/** Alleen het eerste antwoord komt bij de klant; een bekende herkomst wordt nooit overschreven. */
export function firstSource(existing: RecordedSource | null | undefined, next: unknown, at: string, via: SourceAskedAt): RecordedSource | null {
  if (existing) return existing
  const source = normalizeSource(next)
  return source ? { ...source, at, via } : null
}
